import Field from 'components/Form/Field';
import {RequiredRules, RequiredType} from 'components/Form/types';
import {getRegisterRules} from 'components/Form/utils';
import useFormError from 'hooks/useFormErrors';
import {FC, ReactNode} from 'react';

import BaseDateTimeSelect, {
    BaseDateTimeSelectProps,
} from '../Base/BaseDateTimeSelect';

export type DateSelectProps = DateSelectRequiredRules &
    Omit<BaseDateTimeSelectProps, 'onChange' | 'value'>;

export type DateSelectRequiredRules = RequiredRules<{
    classNameSelect?: string;
    helpText?: ReactNode;
    label?: ReactNode;
    name: string;
    requiredType?: RequiredType;
    type?: never;
}>;

const DateSelect: FC<DateSelectProps> = ({
    className,
    classNameSelect,
    disabled,
    helpText,
    isCompact = false,
    label,
    name,
    required,
    requiredType,
    rules,
    ...rest
}) => {
    const registerRules = getRegisterRules({disabled, required, rules});

    const fieldError = useFormError(name);

    return (
        <Field
            className={className}
            disabled={registerRules?.disabled}
            error={fieldError}
            helpText={helpText}
            isCompact={isCompact}
            label={label}
            name={name}
            required={!!registerRules?.required}
            requiredType={requiredType}
            type="select"
        >
            <BaseDateTimeSelect
                className={classNameSelect}
                disabled={registerRules?.disabled}
                error={fieldError}
                isCompact={isCompact}
                name={name}
                required={!!registerRules?.required}
                {...rest}
            />
        </Field>
    );
};

export default DateSelect;
